<template>
    <div>
        <el-table
            class="rounded"
            v-loading="loading"
            :data="data"
            align="center"
            border
        >
            <!-- Nome -->
            <el-table-column label="Nome" min-width="180" align="left">
                <template slot-scope="scope">
                   <span>{{ scope.row.nome }}</span>
                </template>
            </el-table-column>

            <!-- Estado -->
            <el-table-column
              label="UF"
              width="60"
              align="left"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.estado }}</span>
                </template>
            </el-table-column>
            
            <!-- Cidade -->
            <el-table-column
              label="Cidade"
              width="200"
              align="left"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.cidade }}</span>
                </template>
            </el-table-column>

            <!-- Prazo pagamento -->
            <el-table-column label="Prazo pagamento" min-width="160" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.prazo.descricao }}</span>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Atualizado em -->
            <el-table-column label="Atualizado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.updated_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Acoes -->
            <el-table-column
              fixed="right"
              :width="50"
              align="right"
            >
              <div slot="header" style="width: 100%;">
                  <i class="el-icon-menu" />
              </div>

              <template slot-scope="scope">
                <el-button
                    size="small"
                    type="danger"
                    plain
                    circle
                    @click="handleDelete(scope.row.id)"
                >
                    <i class="el-icon-delete"></i>
                </el-button>
              </template>
            </el-table-column>

            <template slot="empty">
                <el-empty description="Nenhuma região centro de distribuição disponível"></el-empty>
            </template>
        </el-table>

        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                  background
                  :current-page.sync="pagination.data.currentPage"
                  :page-sizes="pagination.pageSizes"
                  :page-size="pagination.data.perPage"
                  layout="total, sizes, prev, pager, next"
                  :total="pagination.total"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>
    </div>
</template>

<script>
    // Components
    import CardBase from "@/components/_macro/CardBase.vue";
    import { Empty, Table, TableColumn, Notification, Popover } from "element-ui";

    // Api
    import { RegiaoCentroDistribuicaoApi } from "@/api/RegiaoCentroDistribuicaoApi.js";
    const regiaoCentroDistribuicaoApi = new RegiaoCentroDistribuicaoApi();

    // Utils
    import { formatDate } from "@/util/formatters";
    import { filter } from "lodash";

    export default {
        name: "regiao-cd-list",
        data() {
            return {
                data: [],
                loading: false,
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                pageOptions: [10, 15, 20, 25],
                sortBy: 'codigo',
                sortDesc: false,
                sortDirection: 'asc',
                filters: {
                    cdId: null,
                },
                pagination: {
                    data: {
                        currentPage: 1,
                        perPage: 15,
                    },
                    pageSizes: [15, 50, 75, 100],
                    total: 0
                },
            }
        },
        methods: {
            async fetch() {
                try {
                    this.loading = true;

                    const res = await regiaoCentroDistribuicaoApi.list({
                        ...this.filters,
                        ...this.pagination.data,
                    });

                    this.data = res.data;
                    this.pagination.total = res.total;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as regiões dos centros de distribuição!'
                    });
                } finally {
                    this.loading = false;
                }
            },
            async destroy(regionCdId) {
                try {
                    this.loading = true;

                    const res = await regiaoCentroDistribuicaoApi.destroy(regionCdId);

                    Notification.success({
                        title: 'Sucesso',
                        message: res?.msg ?? 'Região deletada com sucesso!'
                    });
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: err?.response?.msg ?? 'Não foi possível criar o centro de distribuição!'
                    });
                } finally {
                    this.loading = false;
                }
            },
            async handleDelete(regionCdId) {
                this.$confirm('Deseja deletar esse recurso? esta ação é irreversível!', 'Deletar região', {
                    confirmButtonText: 'Deletar',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    await this.destroy(regionCdId); 

                    await this.fetch();
                })
            },
            /*
            *Pagination 
            *
            */
            handlePageChange(page) {
                this.pagination.data.currentPage = page;
                this.fetch();
            },
            handleSizeChange(val) {
                this.pagination.data.perPage = val;
                this.pagination.data.currentPage = 1;
                this.fetch();
            },
            formatDate
        },
        watch: {
            "filters": {
                handler(_newValue) {
                    this.fetch(_newValue);
                },
                deep: true,
            }
        },
        mounted() {
            this.fetch(this.filters);
        },
        components: {
            CardBase,
            // CdEditModal,
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Notification.name]: Notification,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/regiao_cd/RegiaoCdList.vue